
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Breadcrumbs } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Breadcrumbs`}</h1>
<p>{`Used to display links (and text) in a sequence to show the path to a page.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Breadcrumbs } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Breadcrumbs
  linkComponent="a"
  crumbs={[{
    label: 'Pages',
  }, {
    label: 'Home',
    url: 'home',
  }, {
    label: 'Project name - 123',
    url: 'project',
    active: true,
  }]} />`} component={Breadcrumbs} mdxType="Playground">
  <Breadcrumbs linkComponent="a" crumbs={[{
        label: 'Pages'
      }, {
        label: 'Home',
        url: 'home'
      }, {
        label: 'Project name - 123',
        url: 'project',
        active: true
      }]} mdxType="Breadcrumbs" />
</Playground>
<p>{`You can also pass an icon with a label, or without.`}</p>
<Playground __position={1} __code={`<Breadcrumbs
  linkComponent="a"
  crumbs={[{
    icon: 'home',
  }, {
    label: 'Page',
    icon: 'flyer',
    url: 'home',
  }, {
    label: 'Project name - 123',
    url: 'project',
    active: true,
  }]} />`} mdxType="Playground">
  <Breadcrumbs linkComponent="a" crumbs={[{
        icon: 'home'
      }, {
        label: 'Page',
        icon: 'flyer',
        url: 'home'
      }, {
        label: 'Project name - 123',
        url: 'project',
        active: true
      }]} mdxType="Breadcrumbs" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;